class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.startTime = this.dataset.starttime;
      this.endTime = this.dataset.endtime;
      this.secondsStart = 1;
      this.parentSelector = this.dataset.parentselector
    }

    connectedCallback() {
      this.render();
    }
  
    render() {
      this.days = this.querySelector(".days__container .days");
      this.hours = this.querySelector(".hours__container .hours");
      this.minutes = this.querySelector(".minutes__container .minutes");
      this.seconds = this.querySelector(".seconds__container .seconds");
      this.intervalId = setInterval(() => {
      // INITIALIZE THE COUNTDOWN ONLY IF CURRENT TIME IS GREATER THAN OR EQUAL TO THE START TIME
      if (new Date() >= new Date(this.startTime) ){
          this.makeTimer(this.days, this.hours, this.minutes, this.seconds);
         }
      }, 1000);
      const parentEl = document.querySelector(this.parentSelector);
      this.parentEl = parentEl
    }
  
    makeTimer(daysElement, hoursElement, minutesElement, secondsElement) {
      let endTime = new Date(this.endTime);
      endTime = Date.parse(endTime) / 1000;
      /* 
        IF START TIME IS GIVEN,
        CALCULATES THE COUNTDOWN BASED ON THE CURRENT TIME AND START TIME,
        IF CURRENT TIME IS GREATER THAN START TIME COUNTDOWN IS FROM CURRENT TIME.
        ELSE
        CALCULATES THE COUNTDOWN FROM CURRENT TIME
      */
      let now;
      if (this.startTime) {
        now = new Date(this.startTime);
        if (new Date() > new Date(this.startTime)){
          now  = new Date()
        }
        now = Date.parse(now) / 1000 + this.secondsStart;
      } else {
        now = new Date();
        now = Date.parse(now) / 1000;
      }
  
      let timeLeft = endTime - now;
      
      /*
        IF ENDTIME REACHES CLEAR THE SET INTERVAL AND HIDES THE PARENT ELEMENT,
        ELSE UNHIDES THE PARENT ELEMENT.
       */ 
      if (timeLeft <= 0){
        this.clearTimer();
      }
      else{
        this.parentEl.classList.add("timer-running")
      }

      let days = Math.floor(timeLeft / 86400);
      let hours = Math.floor((timeLeft - days * 86400) / 3600);
      let minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
      let seconds = Math.floor(
        timeLeft - days * 86400 - hours * 3600 - minutes * 60
      );
  
      if (hours < "10") {
        hours = "0" + hours;
      }
      if (minutes < "10") {
        minutes = "0" + minutes;
      }
      if (seconds < "10") {
        seconds = "0" + seconds;
      }

      daysElement.innerHTML = days;
      hoursElement.innerHTML = hours;
      minutesElement.innerHTML = minutes;
      secondsElement.innerHTML = seconds;
    }

    clearTimer(){
      clearInterval(this.intervalId);
      this.parentEl.classList.remove("timer-running")
    }
  }
  
  customElements.define("countdown-timer", CountdownTimer);